import { createContext, ReactNode, useContext } from 'react';

interface MasterDocumentsScope {
	/** Set when editing an organisation's Programme Defaults; absent on a programme route. */
	organizationId?: string;
}

// Defaults to the programme tier, whose ids come from the route — so only the organisation
// page has to provide anything.
const MasterDocumentsScopeContext = createContext<MasterDocumentsScope>({});

export const MasterDocumentsScopeProvider = ({
	children,
	organizationId,
}: {
	children: ReactNode;
	organizationId?: string;
}) => (
	<MasterDocumentsScopeContext.Provider value={{ organizationId }}>
		{children}
	</MasterDocumentsScopeContext.Provider>
);

export const useMasterDocumentsScope = (): MasterDocumentsScope =>
	useContext(MasterDocumentsScopeContext);
